<template>
  <v-card>
    <v-subheader style="display:flex; justify-content: space-between;">
      <v-btn icon @click="$emit('back')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <h2>Scheme Details</h2>
      <span style="color:transparent">X</span>
    </v-subheader>
    <div v-if="this.cashbacks && this.cashbacks.length">
      <div style="width: fit-content; background:#fffcf0;margin:auto;padding:1rem;">
        <div>₹ {{sum}}/1500</div>
        <div>
          <span style="margin-right: .5rem">{{upiId}}</span>

          <v-dialog transition="dialog-bottom-transition" max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn style="background: #80808087; border: none" v-bind="attrs" v-on="on" icon x-small outlined raised
                rounded>
                <v-icon x-small color="white">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:default="dialog">
              <v-card style="padding:1rem">
                <h1 style="text-align:left">Enter your UPI ID</h1>
                <div style="text-align:left; font-weight: bold; margin: 1rem 0;">in which you want to receive <br />
                  monthly bonus</div>
                <v-text-field style="margin: 1rem 0;" placeholder="sharma@okicici" class="pt-0" outlined dense
                  v-model="upiId" type="text">
                </v-text-field>
                <v-card-actions class="justify-end">
                  <v-btn text @click="dialog.value = false">Cancel</v-btn>
                  <v-btn text @click="saveUPI();dialog.value = false">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </div>

      </div>

      <v-list>
        <div v-for="(cb, index) in cashbacks" :key="'cb-' + index" class="cashback">
          <h3>Cashback {{index + 1}}</h3>
          <div class="status">{{cb.status}}</div>
          <h1 style="color:#48bb78">₹ {{cb.amount}}</h1>
          <h4>Date</h4>
          <div>{{cb.date}}</div>
          <hr style="margin: .5rem 0; border-color: #d4d4d41c">
          <h4>Transferred to UPI ID</h4>
          <div>{{cb.upi}}</div>
        </div>
      </v-list>
    </div>
    <div v-if="!(this.cashbacks && this.cashbacks.length)" style="text-align:center; margin: 2rem 0;">
      Loading payments
    </div>

  </v-card>
</template>
<style scoped lang="scss">
  .cashback {
    flex-direction: column;
    display: flex;
    background: #fbfbfb;
    margin: 1rem;
    padding: 1rem;
    position: relative;

    >* {
      width: 100%;
      text-align: left;
    }

    .status {
      position: absolute;
      right: 1rem;
      top: 1rem;
      border-radius: 15px;
      padding: .2rem 1rem;
      color: white;
      width: auto;
      font-size: .8rem;
      background: green;
    }
  }
</style>
<script>
  import WIOM_APIS from '../../utils/wiom-apis';
  export default {
    props: ["location", "mobile"],
    data: function () {
      return {
        upi: '',
        cashbacks: [],
        sum: 0,
        dialog: false,
      };
    },
    methods: {
      saveUPI: function () {
        let details = {}
        details.time = new Date();
        details.time = details.time.toISOString().substring(0, 10);
        details.sheet_name = 'gaurentee';
        details.to_address = 'sajal.sharma@i2e1.com';
        details.mobile = this.mobile;
        details.upi = this.upiId;
        details.action = 'post';
        details.nasid = this.location.nasid;
        WIOM_APIS.toSpreadSheet(details);
      }
    },
    mounted: function () {
      if (this.location.nasid) {
        WIOM_APIS.searchSpreadSheet({
          sheet_name: 'cashback',
          key: 'nasid',
          value: this.location.nasid
        })
        .then(res => {
          this.cashbacks = res.sheet_data
          this.cashbacks.forEach(cb => {
            this.sum += cb.amount;
            this.upiId = cb.upi;
          });
        })
      }
    }
  };
</script>